import Project from "models/project/project.model";
import User from "models/user/user.model";

export default class TicketCategory {
    public id: string = "";
    public name: string = "";
    public icon: string = "";
    public color: string = "";
    public project: Project = new Project();
    public createdAt: Date = new Date();
    public createdBy: User = new User();

        /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.name) {
            this.name = String(model.name);
        }
        if (model.icon) {
            this.icon = String(model.icon);
        }
        if (model.color) {
            this.color = String(model.color);
        }
        if (model.project) {
            this.project = new Project(model.project);
        }
        if (model.createdAt) {
            this.createdAt = new Date(model.createdAt);
        }
        if (model.createdBy) {
            this.createdBy = new User(model.createdBy);
        }
    }
}